import React from 'react';
import CustomDropdown from './CustomDropdown';
import './LanguageSelector.css';

interface LanguageSelectorProps {
  currentLanguage: string;
  onLanguageChange: (language: string) => void;
}

const SUPPORTED_LANGUAGES = [
  { code: 'en-US', name: 'English (US)', flag: '🇺🇸' },
  { code: 'en-GB', name: 'English (UK)', flag: '🇬🇧' },
  { code: 'en-AU', name: 'English (Australia)', flag: '🇦🇺' },
  { code: 'en-CA', name: 'English (Canada)', flag: '🇨🇦' },
  { code: 'en-IN', name: 'English (India)', flag: '🇮🇳' },
  { code: 'en-NZ', name: 'English (New Zealand)', flag: '🇳🇿' },
  { code: 'en-ZA', name: 'English (South Africa)', flag: '🇿🇦' },
  { code: 'en-IE', name: 'English (Ireland)', flag: '🇮🇪' },
  { code: 'en-SG', name: 'English (Singapore)', flag: '🇸🇬' },
  { code: 'en-PH', name: 'English (Philippines)', flag: '🇵🇭' },
];

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  currentLanguage,
  onLanguageChange
}) => {
  return (
    <div className="language-selector">
      <label htmlFor="language-select" className="language-label">
        Speech Recognition Accent:
      </label>
      <CustomDropdown
        id="language-select"
        value={currentLanguage}
        options={SUPPORTED_LANGUAGES.map(lang => ({
          value: lang.code,
          label: `${lang.flag} ${lang.name}`
        }))}
        onChange={onLanguageChange}
      />
      <div className="language-hint">
        Select the accent closest to yours for better recognition accuracy
      </div>
    </div>
  );
};

export default LanguageSelector;